module.exports = __webpack_public_path__ + "static/media/updates.b9258c2e.svg";